import React from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import TrueImpactButton from 'shared/design-system/components/TrueImpactButton';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { SupportText } from '../IndicatorDetails/IndicatorSummary/InfoModal';

interface LockImpactSummaryProps {
  handleNext: () => unknown;
}

const StyledDiv = styled.div`
  max-width: 750px;
  padding-top: ${SPACERS.large};
  .support-text,
  .sub-content {
    margin-bottom: ${SPACERS.medium};
  }
`;

const LockImpactSummary: React.FC<LockImpactSummaryProps> = ({
  handleNext,
}) => {
  return (
    <StyledDiv>
      <TrueImpactText variant="heading">
        Impact Model Builder is completed!
      </TrueImpactText>
      <TrueImpactText className="sub-content">
        You’ve already answered all of the questions in this section. If you
        need to make any changes to your impact model, you can make them from
        the full impact model view.
      </TrueImpactText>
      <SupportText className="support-text" />
      <TrueImpactButton onClick={handleNext}>
        Continue to Impact Model Details
      </TrueImpactButton>
    </StyledDiv>
  );
};

export default LockImpactSummary;
